<template>
  <div class="layout">
    <transition name="el-fade-in-linear">
      <div>
        <div class="header" v-if="showHeader">
          <div class="menu" @click="isSidebarOpen = !isSidebarOpen">
            <!-- <i class="left-icon iconfont icon-caidan"></i> -->
            <i class=""></i>
          </div>
          <div class="search" @click="tosearch">
            <!-- <i class="logo-icon iconfont icon-sousuo"></i> -->
            <i class=""></i>
          </div>
          <div class="centerLogo" @click="toHome">
            <i class="logo-icon"></i>
          </div>
          <div
            class="right"
            @click="tolive"
            v-if="webConfig.liveShow.value === '1'"
          >
            <!-- <i class="logo-icon iconfont icon-sousuo"></i> -->
            <i class=""></i>
          </div>
        </div>
      </div>
    </transition>

    <!-- 侧边栏 -->
    <b-sidebar
      id="sidebar-variant"
      class="slidebar"
      title
      bg-variant="dark"
      text-variant="light"
      backdrop
      shadow
      no-header
      v-model="isSidebarOpen"
    >
      <template class="out-container">
        <div class="inner-container">
          <div class="content">
            <div class="close_icon">
              <div class="close_box" @click="isSidebarOpen = !isSidebarOpen">
                <img src="@/assets/imgs/layout/close_purple.png" alt />
              </div>
            </div>
            <b-row class="m-0 text-center">
              <div class="search-box" @click="tosearch">
                <!-- <input type="text" ref="search" disabled /> -->
                <div class="search-in">
                  <img
                    src="@/assets/imgs/layout/search_purple.png"
                    alt
                    width="15px"
                  />
                  Search
                </div>
              </div>
            </b-row>
            <b-row class="m-0">
              <xcollapse></xcollapse>
            </b-row>
            <b-row class="m-0">
              <About></About>
            </b-row>
            <IconGroup></IconGroup>
          </div>
        </div>
      </template>
    </b-sidebar>
  </div>
</template>
<script>
import xcollapse from "./layoutchild/Collapse.vue";
import IconGroup from "./layoutchild/IconGroup.vue";
import About from "./layoutchild/About.vue";
import { mapState } from "vuex";
import { debounce } from "@/components/common/other/common.js";

export default {
  name: "Layout",
  components: {
    xcollapse,
    IconGroup,
    About,
  },
  computed: {
    ...mapState(["webConfig"]),
  },
  data() {
    return {
      searchflag: true,
      // 滚动时，判断是否显示header
      showHeader: true,
      i: 0,
      isSidebarOpen: false,
    };
  },
  mounted() {
    // 第二个参数大于50 可以解决ie中的头部不显示问题,但是在其他浏览器过快上下滚动会是头部消失
    if (document.all) {
      window.addEventListener("scroll", this.pageScroll);
    } else {
      window.addEventListener("scroll", debounce(this.pageScroll, 30));
    }
  },
  destroyed() {
    document.removeEventListener("scroll", this.pageScroll);
  },
  methods: {
    toHome() {
      this.$router.push("/home").catch((err) => {
        err;
      });
    },
    tosearch() {
      if (this.$route.path.indexOf("/search") !== -1) {
        this.isSidebarOpen = false;
        // this.$router
        //   .push("/home")
        //   .then(() => {
        //     this.$router.push("/search");
        //   })
        //   .catch((err) => {
        //     err;
        //   });
      } else {
        this.$router.push("/search").catch((err) => {
          err;
        });
      }
    },
    tolive() {
      this.$router.push("/Live");
    },
    pageScroll() {
      // console.log(213);
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var scroll = scrollTop - this.i;
      this.i = scrollTop;

      let head = document.querySelectorAll(".header");

      if (scroll <= 0) {
        // this.showHeader = true;
        head[0].classList.remove("p_static");
        head[0].classList.add("p_fixed");
      } else {
        head[0].classList.remove("p_fixed");
        head[0].classList.add("p_static");
        // head[0].style.marginTop = 1.3 + "rem";
      }
      if (scrollTop <= 0) {
        head[0].classList.remove("p_fixed");
        head[0].classList.add("p_static");
      }
    },
  },
};
</script>
<style lang="less">
@media screen and (max-width: 768px) {
  .layout {
    .showHeader {
      display: block;
    }

    .bg-dark {
      background: #ffffff !important;
    }

    .p_static {
      position: static;
    }

    .p_fixed {
      position: fixed;
      top: 0;
      left: 0;
    }

    .header {
      background: #fff;
      height: 1rem;
      min-height: 60px;
      z-index: 1000;
      width: 100%;
      box-shadow: 3px 0px 4px 0px rgba(38, 13, 90, 1);

      .menu {
        float: left;
        margin: 0 0 0 0.38rem;
        height: 100%;
        display: flex;
        align-items: center;

        i {
          height: 0.41rem;
          width: 0.47rem;
          display: block;
          color: #ffffff;
          font-size: 0.55rem !important;
          cursor: pointer;
          background: url("../../../assets/imgs/layout/new_menu_black.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }

      .search {
        float: left;
        margin: 0 0 0 0.38rem;
        height: 100%;
        display: flex;
        align-items: center;

        i {
          height: 0.46rem;
          width: 0.46rem;
          display: block;
          color: #ffffff;
          font-size: 0.55rem;
          cursor: pointer;
          background: url("../../../assets/imgs/layout/new_search_black.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }

      .centerLogo {
        cursor: pointer;
        float: left;
        height: 100%;
        width: calc(100% - 3.38rem);
        display: flex;
        align-items: center;

        i {
          // height: 0.59rem;
          // width: 2.59rem;
          // height: 0.708rem;
          // width: 3.108rem;
          height: 1rem;
          width: 4.38228rem;
          display: block;
          background: url("../../../assets/imgs/layout/logo_purple.png")
            no-repeat;
          background-size: 100% 100%;
          margin: 0.25rem auto;
        }
      }

      .right {
        float: right;
        margin: 0 0.413rem 0 0.413rem;
        height: 100%;
        display: flex;
        align-items: center;

        i {
          height: 0.666rem;
          width: 0.864rem;
          display: block;
          color: #ffffff;
          font-size: 0.55rem;
          cursor: pointer;
          background: url("../../../assets/imgs/layout/live_black.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }
    }

    .b-sidebar-body::-webkit-scrollbar {
      display: none;
    }

    // IE 10+
    .b-sidebar-body {
      -ms-overflow-style: none;
    }

    html {
      -ms-overflow-style: none;
    }

    // Firefox
    .b-sidebar-body {
      overflow: -moz-scrollbars-none;
    }

    .b-sidebar {
      z-index: 1001;
    }

    .b-sidebar > .b-sidebar-header {
      padding: 0;

      .b-icon.bi {
        font-size: 30px;
      }
    }

    //  closeIcon
    .close_icon {
      height: 50px;
      width: 100%;
      display: block;
      font-size: 30px;
      padding-right: 10px;

      .close_box {
        height: 20px;
        width: 20px;
        float: right;
        margin: 10px 10px 10px 10px;
        cursor: pointer;
      }

      img {
        height: 100%;
        width: 100%;
      }
    }

    .search-box {
      cursor: pointer;
      width: 92%;
      height: 40px;
      line-height: 40px;
      background: rgba(34, 12, 87, 0.1);
      margin: 20px 24px auto !important;
      font-size: 20px;
      position: relative;
      border-radius: 4px;

      input {
        background: transparent;
        color: #867ead;
      }

      .search-in {
        position: absolute;
        opacity: 0.5;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        font-size: 20px;
        font-family: FranklinGothic-Demi, FranklinGothic;
        font-weight: normal;
        color: #867ead;

        img {
          margin-right: 8px;
          width: 15px;
          height: 15px;
        }
      }
    }

    .vedio {
      width: calc(100% - 100px);
      margin: 0 50px;
    }
  }
}

@media screen and (min-width: 768px) {
  .layout {
    .showHeader {
      display: block;
    }

    .bg-dark {
      background: #ffffff !important;
    }

    .p_static {
      position: static;
    }

    .p_fixed {
      position: fixed;
      top: 0;
      left: 0;
    }

    .header {
      background: #fff;
      height: 1rem;
      z-index: 1000;
      width: 100%;
      box-shadow: 3px 0px 4px 0px rgba(38, 13, 90, 1);

      .menu {
        float: left;
        margin: 0 0 0 0.38rem;
        height: 100%;
        display: flex;
        align-items: center;

        i {
          height: 0.41rem;
          width: 0.47rem;
          display: block;
          color: #ffffff;
          font-size: 0.55rem !important;
          cursor: pointer;
          background: url("../../../assets/imgs/layout/new_menu_black.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }

      .search {
        float: left;
        margin: 0 0 0 0.38rem;
        height: 100%;
        display: flex;
        align-items: center;

        i {
          height: 0.46rem;
          width: 0.46rem;
          display: block;
          color: #ffffff;
          font-size: 0.55rem;
          cursor: pointer;
          background: url("../../../assets/imgs/layout/new_search_black.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }

      .centerLogo {
        cursor: pointer;
        float: left;
        height: 100%;
        width: calc(100% - 3.2rem);
        display: flex;
        align-items: center;

        i {
          height: 0.59rem;
          width: 2.59rem;
          display: block;
          background: url("../../../assets/imgs/layout/logo_purple.png")
            no-repeat;
          background-size: 100% 100%;
          margin: 0.25rem auto;
        }
      }

      .right {
        float: right;
        margin: 0 0.5rem 0 0.5rem;
        height: 100%;
        display: flex;
        align-items: center;

        i {
          height: 0.37rem;
          width: 0.47rem;
          display: block;
          color: #ffffff;
          font-size: 0.55rem;
          cursor: pointer;
          background: url("../../../assets/imgs/layout/live_black.png")
            no-repeat;
          background-size: 100% 100%;
        }
      }
    }

    .b-sidebar-body::-webkit-scrollbar {
      display: none;
    }

    // IE 10+
    .b-sidebar-body {
      -ms-overflow-style: none;
    }

    html {
      -ms-overflow-style: none;
    }

    // Firefox
    .b-sidebar-body {
      overflow: -moz-scrollbars-none;
    }

    .b-sidebar {
      z-index: 1001;
    }

    .b-sidebar > .b-sidebar-header {
      padding: 0;

      .b-icon.bi {
        font-size: 30px;
      }
    }

    //  closeIcon
    .close_icon {
      height: 50px;
      width: 100%;
      display: block;
      font-size: 30px;
      padding-right: 10px;

      .close_box {
        height: 20px;
        width: 20px;
        float: right;
        margin: 10px 10px 10px 10px;
        cursor: pointer;
      }

      img {
        height: 100%;
        width: 100%;
      }
    }

    .search-box {
      cursor: pointer;
      width: 92%;
      height: 40px;
      line-height: 40px;
      background: rgba(34, 12, 87, 0.1);
      margin: 20px auto !important;
      font-size: 20px;
      position: relative;
      border-radius: 4px;

      input {
        background: transparent;
        color: #867ead;
      }

      .search-in {
        position: absolute;
        opacity: 0.5;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: flex;
        align-items: center;
        font-size: 20px;
        font-family: FranklinGothic-Demi, FranklinGothic;
        font-weight: normal;
        color: #867ead;

        img {
          margin-right: 8px;
          width: 15px;
          height: 15px;
        }
      }
    }

    .vedio {
      width: calc(100% - 100px);
      margin: 0 50px;
    }
  }
}
</style>
